"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRobots = exports.getAlias = exports.getTitle = void 0;

var _HelmetHelper = require("./HelmetHelper");

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getTitle = function getTitle(domain, lang, helmetType, data) {
  var agencyDetail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var pdpDetail = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var withZone = arguments.length > 6 ? arguments[6] : undefined;
  var moreDetail = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var surrounding = '';

  if (data.filters && (data.filters.surroundingSuburbs === true || data.filters.surroundingSuburbs === 'true')) {
    surrounding = ' e dintorni';
  }

  var channel = data.channel,
      _data$filters = data.filters,
      category = _data$filters.category,
      propertyTypes = _data$filters.propertyTypes,
      roomsRange = _data$filters.roomsRange,
      agentCategory = _data$filters.agentCategory,
      poi = _data$filters.poi,
      license_type_groups = _data$filters.license_type_groups,
      sortType = data.sortType;
  var descTr = channel ? " in ".concat(channel) : '';
  var propertyTypesDesc = propertyTypes.length || license_type_groups.length ? (0, _HelmetHelper.getPropertyTypes)(propertyTypes, license_type_groups) : '';
  var isPType = propertyTypesDesc && propertyTypesDesc.trim().length > 0 && propertyTypesDesc.trim().toLocaleLowerCase() !== 'annunci';
  var roomsCondition = roomsRange.minimum !== 'any' && roomsRange.minimum === roomsRange.maximum;
  var rooms = roomsCondition ? "".concat((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum), " ") : ' ';
  var isRooms = rooms && rooms.trim().length > 0 && rooms.trim().toLocaleLowerCase() !== 'case';
  var roomsDesc = "".concat(isPType ? "".concat(isRooms ? rooms : '') : rooms); // calcoliamo l'eventuale parte della descrizione che riporta il valore del sorting

  var sortValue = (0, _HelmetHelper.getSortValuePart)(category, propertyTypes, isRooms, sortType);
  var startDesc = propertyTypesDesc === 'Appartamenti' && isRooms ? (0, _HelmetHelper.capitalize)(roomsDesc) : propertyTypesDesc;
  var fd = data.features ? data.features.map(function (f) {
    return _HelmetHelper.FEATURES_LABEL[f];
  }).join(', ') : '';
  var ncommas = fd.split(/,/).length;
  var pos = fd.lastIndexOf(',');
  var featuresDesc = (0, _HelmetHelper.getFeaturesDesc)(data.features, ncommas, fd, pos);
  var bcNew = data.filters && data.filters.buildingCondition && _HelmetHelper.BUILDING_CONTITIONS_LABEL[data.filters.buildingCondition] ? " ".concat(_HelmetHelper.BUILDING_CONTITIONS_LABEL[data.filters.buildingCondition].toLocaleLowerCase()) : '';
  var pageDescr = '';
  var priceRange = ''; // getRange(data.filters.priceRange);

  var publisherType = agentCategory === 'all' ? '' : (0, _HelmetHelper.getAgentCategory)(agentCategory);
  var nearPointOfInterest = '';

  if (poi) {
    if (poi.subway) {
      nearPointOfInterest = ' vicino alla metro';
    } else if (poi.electric_charging) {
      nearPointOfInterest = ' vicino a colonnine ricarica auto elettriche';
    }
  }

  var agencyFt = data.agencyFt ? ' corrispondenti alla tua ricerca' : '';
  var isAuctionOrNakedProperty = (0, _HelmetHelper.getAuctionOrNakedProperty)({
    features: data.features,
    propertyTypes: isPType ? startDesc : '',
    sortValue: sortValue,
    bcNew: bcNew
  });
  var prefixDesc = isAuctionOrNakedProperty ? "".concat((0, _HelmetHelper.capitalize)(isAuctionOrNakedProperty.text.toLowerCase())).concat(propertyTypesDesc !== 'Appartamenti' && isRooms ? " ".concat(roomsDesc) : '') : "".concat(startDesc).concat(sortValue).concat(propertyTypesDesc !== 'Appartamenti' && isRooms ? " ".concat(roomsDesc) : '');
  var SEOTitleEnd = ' - Casa.it';

  switch (helmetType) {
    case _HelmetHelper.HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', ", annunci immobiliari vendita a ").concat(agencyDetail.address.suburb, " - ").concat(domain === 'attico' ? 'Attico.it' : ' - Casa.it');

    case _HelmetHelper.HELMET_AGENCY_NOT_FOUND_TYPE:
      return 'Agenzia non trovata - Casa.it';

    case _HelmetHelper.HELMET_AGENCY_SRP_TYPE:
      return "Agenzie Immobiliari ".concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', true)).concat(agencyFt).concat(SEOTitleEnd);

    case _HelmetHelper.HELMET_SRP_TYPE:
      {
        switch (category) {
          case 'commerciale':
            return "".concat((0, _HelmetHelper.getPropertyTypes)(propertyTypes, license_type_groups)).concat(!roomsCondition ? ' ' : " con ".concat(roomsRange.minimum, " locali ")).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'vacanze':
            return "".concat(prefixDesc, " per vacanze").concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'case-vacanza':
            return "".concat(prefixDesc).concat(featuresDesc).concat(bcNew).concat(descTr, " breve").concat(publisherType).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          default:
            return isAuctionOrNakedProperty ? "".concat(isAuctionOrNakedProperty.text).concat(featuresDesc).concat(publisherType).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(SEOTitleEnd) : "".concat(prefixDesc).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);
        }
      }

    case _HelmetHelper.HELMET_SRP_NO_LOC_TYPE:
      {
        switch (category) {
          case 'commerciale':
            return "".concat((0, _HelmetHelper.getPropertyTypes)(propertyTypes, license_type_groups)).concat(!roomsCondition ? ' ' : " ".concat(roomsRange.minimum, " locali ")).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType, " tra gli immobili commerciali").concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'case-vacanza':
            return "".concat(prefixDesc, " per vacanze").concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'terreni':
          case 'cantine-solai':
          case 'garage-posti-auto':
          case 'stanze':
          default:
            return "".concat(prefixDesc).concat(featuresDesc).concat(bcNew).concat(isAuctionOrNakedProperty ? '' : descTr).concat(nearPointOfInterest).concat(publisherType).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);
        }
      }

    case _HelmetHelper.HELMET_SRP_NO_PROP_TYPE:
      {
        var SEOTitleStart;

        switch (category) {
          case 'commerciale':
            SEOTitleStart = "".concat(license_type_groups.length ? (0, _HelmetHelper.getPropertyTypes)([], license_type_groups) : (0, _HelmetHelper.getCategoryDefault)(category)).concat(!roomsCondition ? ' ' : " con ".concat(roomsRange.minimum, " local").concat(parseInt(roomsRange.minimum, 10) === 1 ? 'e' : 'i')).concat(featuresDesc).concat(bcNew, " ").concat(descTr).concat(publisherType);
            return "".concat(SEOTitleStart, " ").concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'case-vacanza':
            // SEOTitleStart = `${getCategoryDefault(category)}${featuresDesc}${bcNew}${descTr}${publisherType}`
            SEOTitleStart = "Case".concat(featuresDesc).concat(bcNew, " in affitto breve").concat(publisherType);
            return "".concat(SEOTitleStart, " ").concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'uffici':
          case 'capannoni':
          case 'edifici-palazzi':
          case 'terreni':
          case 'cantine-solai':
          case 'garage-posti-auto':
          case 'stanze':
            SEOTitleStart = "".concat((0, _HelmetHelper.getCategoryDefault)(category)).concat(!roomsCondition ? ' ' : " con ".concat(roomsRange.minimum, " local").concat(parseInt(roomsRange.minimum, 10) === 1 ? 'e' : 'i')).concat(featuresDesc).concat(bcNew, " ").concat(descTr).concat(publisherType);
            return "".concat(SEOTitleStart).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          default:
            var rentLocationsQualifyForNewTitle = (0, _HelmetHelper.checkIfRentLocationsQualifyForNewTitle)({
              locations: data.locations,
              channel: channel,
              bcNew: bcNew,
              publisherType: publisherType,
              roomsCondition: roomsCondition,
              featuresDesc: featuresDesc,
              nearPointOfInterest: nearPointOfInterest,
              surrounding: surrounding,
              pageDescr: pageDescr,
              priceRange: priceRange
            });

            if (rentLocationsQualifyForNewTitle) {
              return "Affitti ".concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(SEOTitleEnd);
            }

            if (isAuctionOrNakedProperty) {
              SEOTitleStart = "".concat(isAuctionOrNakedProperty.text).concat(featuresDesc).concat(publisherType);
            } else if (roomsCondition) {
              SEOTitleStart = "".concat((0, _HelmetHelper.capitalize)((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum))).concat(sortValue).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType);
            } else {
              SEOTitleStart = "".concat((0, _HelmetHelper.getCategoryDefault)(category)).concat(sortValue).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType);
            }

            return "".concat(SEOTitleStart).concat(nearPointOfInterest).concat((0, _HelmetHelper.getLocalities)(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);
        }
      }

    case _HelmetHelper.HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        var _SEOTitleStart;

        switch (category) {
          case 'commerciale':
            var ltg = license_type_groups.length ? (0, _HelmetHelper.getPropertyTypes)([], license_type_groups) : 'Immobili e Attività commerciali';
            _SEOTitleStart = !roomsCondition ? ltg : "".concat(ltg, " con ").concat(roomsRange.minimum, " local").concat(roomsRange.minimum === 1 ? 'e' : 'i');
            return "".concat(_SEOTitleStart).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(pageDescr).concat(SEOTitleEnd);

          case 'vacanze':
            _SEOTitleStart = !roomsCondition ? 'Case vacanze' : roomsRange.minimum[0] === '1' ? 'Case vacanze con 1 locale' : "".concat((0, _HelmetHelper.capitalize)((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum)), " per vacanze");
            return "".concat(_SEOTitleStart).concat(featuresDesc).concat(bcNew).concat(descTr).concat(publisherType).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          case 'case-vacanza':
            _SEOTitleStart = roomsCondition ? "".concat((0, _HelmetHelper.capitalize)((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum))).concat(featuresDesc).concat(bcNew, " in affitto breve") : "Case ".concat(featuresDesc).concat(bcNew, " in affitto breve");

            if (typeof category === 'undefined') {
              _SEOTitleStart = "Immobili".concat(featuresDesc).concat(bcNew, " in affitto breve");
            }

            return "".concat(_SEOTitleStart).concat(publisherType).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);

          default:
            _SEOTitleStart = roomsCondition ? "".concat((0, _HelmetHelper.capitalize)((0, _HelmetHelper.getRoomsRange)(roomsRange.minimum))).concat(sortValue).concat(featuresDesc).concat(bcNew).concat(descTr) : "".concat((0, _HelmetHelper.getCategoryDefault)(category)).concat(sortValue).concat(featuresDesc).concat(bcNew).concat(descTr);

            if (typeof category === 'undefined') {
              _SEOTitleStart = "Immobili".concat(sortValue).concat(featuresDesc).concat(bcNew).concat(descTr);
            }

            if (isAuctionOrNakedProperty) {
              _SEOTitleStart = "".concat(isAuctionOrNakedProperty.text);
            }

            return "".concat(_SEOTitleStart).concat(nearPointOfInterest).concat(publisherType).concat(pageDescr).concat(priceRange).concat(SEOTitleEnd);
        }
      }

    case _HelmetHelper.HELMET_PDP:
      {
        var _channel = _SeoManagerHelpers.TR_ENCODE[lang][pdpDetail.channel];
        var address = pdpDetail.address && pdpDetail.address.trim() !== '' ? pdpDetail.address : null;

        var _rooms = pdpDetail.rooms || 'appartamento';

        var price = pdpDetail.priceRange && pdpDetail.priceRange === 'Trattativa riservata' ? " - ".concat(pdpDetail.priceRange) : pdpDetail.priceRange ? " - ".concat((0, _HelmetHelper.integerWithEuropeThousandSeparator)(pdpDetail.priceRange), "\u20AC") : '';

        var _priceRange = !address && pdpDetail.priceRange && pdpDetail.propertyType !== 'nuova-costruzione' ? " - ".concat(price) : '';

        var mq = pdpDetail.mq && pdpDetail.propertyType !== 'nuova-costruzione' ? " - ".concat(pdpDetail.mq, "mq") : '';
        var hasZone = pdpDetail.zone ? pdpDetail.zone.split('|') : null;
        var zone = hasZone ? hasZone[hasZone.length - 1] : null;
        var withAddress = address ? address : null;

        var _withZone = zone ? zone : null;

        var addressOrZoneOrNothing = withAddress ? " in ".concat(withAddress) : _withZone ? " in zona ".concat(_withZone) : '';
        var floor = pdpDetail.floor ? " - ".concat(pdpDetail.floor, " ").concat(pdpDetail.floor.indexOf('piano') === -1 ? 'piano' : '') : '';
        var moreInfo = moreDetail.isAChildOfProjectProfile ? "".concat(mq).concat(floor).concat(price) : "".concat(mq);
        var typeLabel = pdpDetail.licenseType || _SeoManagerHelpers.PROPERTY_TYPES_SINGULAR[pdpDetail.propertyType];
        var startTitle = "".concat(pdpDetail.propertyType === 'appartamento' ? (0, _HelmetHelper.capitalize)((0, _HelmetHelper.getRoomRange)(_rooms)) : typeLabel);
        var finalTitle = " in ".concat((0, _HelmetHelper.capitalize)(_channel)).concat(addressOrZoneOrNothing, " a ").concat((0, _HelmetHelper.capitalize)(pdpDetail.city)).concat(moreInfo);
        return "".concat(startTitle).concat(finalTitle, " - Casa.it");
      }
  }
}; // export const getAliasH2 = ({ alias = '' }) => {
//   let aliasH2 = '';
//   if (alias !== '') {
//     aliasH2 = `Questa zona include gli immobili in ${alias}`;
//   }
//   return aliasH2;
// }


exports.getTitle = getTitle;

var getAlias = function getAlias(_ref) {
  var _ref$locations = _ref.locations,
      locations = _ref$locations === void 0 ? [] : _ref$locations;
  var aliasH2 = '';

  if (locations.length === 1) {
    locations.forEach(function (l) {
      if (l.name_alias) {
        aliasH2 = l.name_alias;
      }
    });
  }

  return aliasH2;
};

exports.getAlias = getAlias;

var getRobots = function getRobots(_ref2) {
  var data = _ref2.data,
      seoParams = _ref2.seoParams,
      locations = _ref2.locations,
      pageType = _ref2.pageType,
      isSrpUrl = _ref2.isSrpUrl,
      count = _ref2.count;
  var robots = 'index, follow';
  var hasTwin = (0, _HelmetHelper.checkSrpUrlHasTwinOnSeoUrl)({
    data: data,
    seoParams: seoParams
  });
  /* 
    ticket history
    TECH-7234
    TECH-7385
    TECH-7648
  */

  var hasMorePages = false;

  if ((locations || []).length) {
    var _locations = _slicedToArray(locations, 1),
        loc = _locations[0]; // se non siamo in una ricerca su mappa


    hasMorePages = loc.level < 999;

    if (locations.length > 1) {
      hasMorePages = false;
    } // seo url senza località (es. /vendita/appartamenti/)

  } else if (!isSrpUrl && pageType === 'TransactionPage' && !seoParams.pId) {
    hasMorePages = true;
  }

  var pageLimit = hasMorePages ? 9 : 1;

  if (data.page > pageLimit || !hasTwin && isSrpUrl || pageType !== 'PDP' && !count) {
    robots = 'noindex, nofollow';
  } else if (!hasTwin && pageType === 'ImmotypePage' || !hasTwin && pageType === 'TransactionPage' && seoParams.pId) {
    robots = 'noindex, follow';
  }

  return robots;
};

exports.getRobots = getRobots;